import React from "react";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8002";

const GoogleSignInButton = ({
  label = "Continue with Google",
  disabled = false,
  // Signup page passes the user's newsletter checkbox state through. The
  // backend reads it from the OAuth state param when creating a brand-new
  // user. Existing users sign in unaffected — the flag is only honored on
  // first-time account creation.
  wantsNewsletter = false,
  // True when the caller has already gated this button on a Terms checkbox
  // (Signup page). Tells the backend to stamp terms_accepted_at=now() on
  // a freshly created user. False (default) means the new user will land
  // on the welcome-terms interstitial after OAuth completes.
  termsAccepted = false,
}) => {
  const handleClick = () => {
    const next = encodeURIComponent(
      `${window.location.origin}${window.location.pathname}#/auth/google/complete`
    );
    const nl = wantsNewsletter ? "1" : "0";
    const ta = termsAccepted ? "1" : "0";
    window.location.href = `${API_BASE_URL}/api/auth/google/?next=${next}&wants_newsletter=${nl}&terms_accepted=${ta}`;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className="font-secondary flex w-full items-center justify-center gap-3 rounded-sm border border-white/15 bg-white/[0.03] px-6 py-3.5 text-[15px] font-medium text-white transition-colors hover:border-white/25 hover:bg-white/[0.06] disabled:cursor-not-allowed disabled:opacity-50"
    >
      <svg className="h-5 w-5 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="#EA4335"
          d="M12 10.2v3.9h5.5c-.2 1.4-1.6 4.1-5.5 4.1-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.7 3.4 14.6 2.4 12 2.4 6.7 2.4 2.4 6.7 2.4 12s4.3 9.6 9.6 9.6c5.5 0 9.2-3.9 9.2-9.4 0-.6-.1-1.1-.2-1.6H12z"
        />
        <path
          fill="#34A853"
          d="M3.9 7.4l3.2 2.4c.9-1.7 2.7-2.8 4.9-2.8 1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.7 3.4 14.6 2.4 12 2.4 8.2 2.4 4.9 4.4 3.9 7.4z"
        />
        <path
          fill="#FBBC05"
          d="M12 21.6c2.6 0 4.7-.9 6.3-2.4l-3-2.4c-.8.6-1.9 1-3.3 1-2.5 0-4.7-1.7-5.4-4l-3.1 2.4c1.5 3.1 4.7 5.4 8.5 5.4z"
        />
        <path
          fill="#4285F4"
          d="M21.2 12.2c0-.6-.1-1.1-.2-1.6H12v3.9h5.5c-.2 1-.9 2.1-1.9 2.7l3 2.4c1.7-1.6 2.6-4 2.6-7.4z"
        />
      </svg>
      {label}
    </button>
  );
};

export default GoogleSignInButton;
